import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import frameProps from '../css/frameProps';
import { updateClasses, getDefaultControl } from './label.defaults';
import Control from './control';
import uniqueId from '../uniqueId';

const defaultFrame = {
        position: 'absolute',
        display: 'block',
        overflow: 'hidden',
        top: '8px',
        left: '8px',
        width: '120px',
        height: '32px',
        userSelect: 'none',
      }

export default class Label extends Control {
  
  renderElement() {
    const control = this;
    const options = this._controlOptions;
    if (!control.el) {
      control.el = getDefaultControl();
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-label-',Label);
        control.styleSheet = 'css-' + control.id;        
      }else{
        control.el.setAttribute('id',control.id);
      }
    }

    updateClasses(control,options);
    var bodyEl = control.el.getElementsByClassName('body')[0];
    

    var frameStylePatch = _.pick(merge({},getDefaultStyle(),defaultFrame, options.style.normal), frameProps);

    let scheme = lookAndFeel(options.lookAndFeel, options.style.normal.height);

    updateStyleByRef(frameStylePatch, scheme);
    updateStyle(control.el, frameStylePatch, control.currentFrameStyle);

    control.currentFrameStyle = frameStylePatch;

    bodyEl.innerHTML = control.text === undefined || control.text === null? '':control.text;

    return control.el;
  }
}
